const defaultLanguage = 'Ro';

const refresh = () => {
  location.reload();
};

module.exports = {
  english() {
    localStorage.setItem('language', 'En');

    window.location = '.';

    refresh();
  },

  romanian() {
    localStorage.setItem('language', 'Ro');

    refresh();
  },

  get language() {
    return localStorage.getItem('language') || defaultLanguage;
  }
};



// WEBPACK FOOTER //
// ./src/services/language.js